// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__jGd0f0","buttons":"buttons__lBXmZv"};